import React from "react";
const list = React.lazy(() => import("./pages/list"));
const management = React.lazy(() => import("./pages/management"));
const Detail = React.lazy(() => import("./pages/details"));

const routes = [
  {
    name: "Devoluciones Mal Estado",
    path: "/disrepair-return",
    component: list,
    exact: true
  },
  {
    name: "Captura de Devolución Mal Estado",
    path: "/disrepair-return/new",
    component: management,
    exact: true
  },
  {
    name: "Detalle de Devolución Mal Estado",
    path: "/disrepair-return/detail/:id",
    component: Detail,
    exact: true
  }
];

export default routes;
